import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LocationContextService } from '../../../../client/app/location-context/location-context.service';
import { ILocationContext } from '../../../../model/location-context';
import { IStatistic } from '../../../../model/statistics';
import { StatisticsService } from '../statistics.service';

@Component({
    selector: 'app-statistics',
    templateUrl: './statistics.component.html',
    styleUrls: ['./statistics.component.scss']
})
export class StatisticsComponent implements OnInit {
    locationContext: ILocationContext;

    statistics$: Observable<IStatistic[]>;

    constructor(
        private readonly statisticsService: StatisticsService,
        private readonly locationContextService: LocationContextService
    ) {}

    ngOnInit() {
        // Get location context
        this.locationContext = this.locationContextService.getLocationContext();

        // Request data
        this.statisticsService.requestStatistics(this.locationContext);

        // Load data
        this.statistics$ = this.statisticsService.getStatistics();
    }
}
